<div class="error-view">
    <h2>{{'error.fullLabel' | translate}}</h2>
    <div [innerHTML]="'error.detail' | translate"></div>
</div>
